import Home from './Home.bundle-ids.vue';
import Edit from './Edit.bundle-ids.vue';

export default {Home, Edit};